import React, { useState } from 'react';
import './Styles.css';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import DefaultAgentConfirmationButtons from './Buttons/DefaultAgentConfirmationButtons';
import ErrorMessage from '../../../../../Elements/ErrorMessage';
import Form from '../../../../../Elements/Form/Form';
import { onSubmit } from './Function';
import Modal from '../../../../../Elements/ids/Modal';

export const defaultAgentConfirmationFormId = 'defaultAgentForm';

const DefaultAgentConfirmation = ({ agent, closeView, team, teamPageDispatch }) => {
  const [error, setError] = useState(null);

  return (
    <Modal
      closeView={closeView}
      titleText={formatMessage(Messages.defaultAgent_setDefaultAgentCode)}
      buttons={<DefaultAgentConfirmationButtons closeView={closeView} error={error} />}>
      <Form
        formId={defaultAgentConfirmationFormId}
        onSubmit={e => {
          onSubmit(e, agent.code, team, teamPageDispatch, setError);
        }}>
        <div className="teamPage-defaultAgent-container">
          <div className="common-table-row teamPage-defaultAgent-row headerRow">
            <div>{formatMessage(Messages.common_agentCode)}</div>
            <div>{formatMessage(Messages.common_costCenter)}</div>
            <div>{formatMessage(Messages.common_externalSalesCode)}</div>
            <div>{formatMessage(Messages.common_activationDate)}</div>
          </div>

          <div className="common-table-row teamPage-defaultAgent-row">
            <div>{agent.code}</div>
            <div>{`${agent.costCenter.name} (${agent.costCenter.code})`}</div>
            <div>{agent.externalSalesCode}</div>
            <div>{agent.validFrom}</div>
          </div>
        </div>

        <ErrorMessage message={error} />
      </Form>
    </Modal>
  );
};

export default DefaultAgentConfirmation;
